import { ReactElement, useEffect, useState } from 'react'
import webStyles from './WebBackgroundSlideshow.module.scss'
import mobileStyles from './MobileBackgroundSlideshow.module.scss'
import { useMatchMedia } from '../../hooks/useMatchMedia'
import { pageBreakpoints } from '../../config/pageBreakpoints'

interface BackgroundSlideshowProps {
  images: string[]
  isMobile?: boolean
  interval?: number // Zeit zwischen Slides in ms
  duration?: number // Übergangszeit in ms
}

export const BackgroundSlideshow = ({
  images,
  interval = 6000,
  duration = 1200,
}: BackgroundSlideshowProps): ReactElement => {
  const isMobile = useMatchMedia(`(max-width:${pageBreakpoints.md})`)

  const [index, setIndex] = useState(0)
  const [isTransitioning, setIsTransitioning] = useState(true)

  const styles = isMobile ? mobileStyles : webStyles

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => prev + 1)
    }, interval)
    return () => clearInterval(timer)
  }, [interval])

  // Endlos-Schleifen-Logik
  useEffect(() => {
    if (index === images.length) {
      setTimeout(() => {
        setIsTransitioning(false)
        setIndex(0)
      }, duration)

      setTimeout(() => {
        setIsTransitioning(true)
      }, duration + 50)
    }
  }, [index, images.length, duration])

  return (
    <div className={styles.slideshow}>
      <div
        className={styles.track}
        style={{
          transform: `translateX(-${index * 100}%)`,
          transition: isTransitioning ? `transform ${duration}ms ease-in-out` : 'none',
        }}
      >
        {images.map((url, i) => (
          <div key={i} className={styles.slide}>
            <img src={url} alt={`Slide ${i}`} />
          </div>
        ))}
        {/* Duplikat vom ersten Bild für nahtlose Endlosschleife */}
        <div className={styles.slide}>
          <img src={images[0]} alt='Slide clone' />
        </div>
      </div>
    </div>
  )
}
